var _       = require('underscore');
var $       = require('jquery');
var Core    = require('../core/core.js');

/**
 * Creates a sidebar group item
 *
 * @class
 */

class SidebarVersionsVersionItem extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                "name": '',
                "description": '',
                "time": ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__sidebar__versions__item">
                <div class="editor__sidebar__versions__item__title"><%- name %></div>
                <div class="editor__sidebar__versions__item__description"><%- description %></div>
                <div class="editor__sidebar__versions__item__time"><%- time %></div>
            </div>
        `;

        super.render();
    }
}
module.exports = SidebarVersionsVersionItem;
